import * as React from "react";
import GeneralSelect from "../general_select";
import PopDetail from "../popdetail";
import {ProjectsService} from "../../service/v1/projects";
import Wait from "../wait";
import SecondLayer from "../container/second_layer";
import ProjectContainer from "../v1/project/project_container";
import uncheck from "../../resources/img/checkbox/checkbox_unchecked.png";
import check from "../../resources/img/checkbox/checkbox_checked.png";

export default class BuyLandUSePane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            project_type: {value: 0},
            zoneOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Zone'},
            regionOptions: {endpoint: 'localities/list', value: 'id', label: 'name', placeholder: 'Select Region'},
            districtOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select District'
            },
            wardOptions: {
                endpoint: 'localities/list',
                value: 'id',
                label: 'name',
                placeholder: 'Select Ward'
            },
            villageOptions: {
                endpoint: `localities/list`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Village'
            },
            projectOptions: {
                endpoint: `projects/public/project-types`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Land Use Type'
            },
            is_village: 'none',
            is_ward: 'none',
            is_district: 'none',
            is_regional: 'none',
            is_zonal: 'none',
            is_village_multi: true,
            is_ward_multi: true,
            is_district_multi: true,
            is_regional_multi: true,
            is_zonal_multi: true,
            is_village_disabled: true,
            is_ward_disabled: true,
            is_district_disabled: true,
            is_regional_disabled: true,
            locality: '',
            project_list: {
                endpoint: 'projects/list',
                value: 'id',
                placeholder: 'Select Project',
                label: 'name'
            },
            search_success: 'none',
            projects: [],
            totalPages: 1,
            next: '',
            previous: '',
            zone: [],
            checkout_disabled_btn: 'table-row',
            search_button: 'none',
            checkout_enabled_btn: 'none',
            checkout_projects: [],
            index: 0,
            checkout_total: 0,
        }

        this.submit = this.submit.bind(this)
        this.search = this.search.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        this.toggleCheck = this.toggleCheck.bind(this)
        this.checkout = this.checkout.bind(this)
    }


    handleChanges = (e) => {
        this.setState({[e.target.name]: e.target.value})
        console.log(e.target.name)

    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
        console.log(name)
        console.log("dv : " + data.value)
        let ids = []

        switch (name) {
            case 'zone':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_regional_disabled: false,
                    regionOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Region'
                    },
                    locality: 'Zonal',
                    search_button: 'table-row',
                })
                break;
            case 'region':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_district_disabled: false,
                    districtOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('district_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select District'
                    },
                    locality: 'Regional',
                    search_button: 'table-row',
                })
                break
            case 'district':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_ward_disabled: false,
                    wardOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('ward_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Ward'
                    },
                    locality: 'District',
                    search_button: 'table-row',
                })
                break
            case 'ward':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                    console.log(ids)
                }
                this.setState({
                    is_village_disabled: false,
                    villageOptions: {
                        endpoint: `localities/list?level_id=` + sessionStorage.getItem('village_level_id') + '&parent_id=' + data.value,
                        value: 'id',
                        label: 'name',
                        placeholder: 'Select Village'
                    },
                    locality: 'Ward',
                    search_button: 'table-row',
                })
                break
            case 'village':
                if (data.length >= 1) {
                    data.forEach(it => {
                        ids.push(it.value)
                    })
                }
                this.setState({
                    locality: 'Village',
                    search_button: 'table-row',
                })
                break
            case 'project_type':
                if (data.label.toString().includes('Village') || data.label.toString().includes('CCRO')) {
                    this.setState({
                        is_ward: 'table-row',
                        is_district: 'table-row',
                        is_village: 'table-row',
                        is_ward_multi: false,
                        is_district_multi: false,
                        is_regional_multi: false,
                        is_regional: 'table-row',
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'Village'
                    })
                }
                if (data.label.toString().includes('District')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'table-row',
                        is_regional: 'table-row',
                        is_regional_multi: false,
                        is_zonal: 'none',
                        regionOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('regional_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Region'
                        },
                        is_regional_disabled: false,
                        locality: 'District'
                    })
                }
                if (data.label.toString().includes('Region')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'table-row',
                        is_zonal: 'table-row',
                        is_zonal_multi: false,
                        zoneOptions: {
                            endpoint: `localities/list?level_id=` + sessionStorage.getItem('zonal_level_id'),
                            value: 'id',
                            label: 'name',
                            placeholder: 'Select Zone'
                        },
                        locality: 'Regional'
                    })
                }
                if (data.label.toString().includes('Zon')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'none',
                        locality: 'Zonal',
                    })
                }
                if (data.label.toString().includes('Nation')) {
                    this.setState({
                        is_village: 'none',
                        is_ward: 'none',
                        is_district: 'none',
                        is_regional: 'none',
                        is_zonal: 'none',
                        locality: 'National',
                    })
                }
                break
        }
    }

    toggleCheck(i, project) {
        let doc = document.getElementById('chk_' + i);
        try {
            if (doc.src === uncheck) {
                doc.src = check;
                console.log('Size : ' + this.state.checkout_projects.length)
                this.setState(prevState => {
                    let newProjects = [...prevState.checkout_projects, project];
                    let newCheckoutTotal = prevState.checkout_total + 10000;
                    //newProjects.push(userId);
                    return {
                        checkout_projects: newProjects, checkout_disabled_btn: 'none',
                        checkout_enabled_btn: 'table-row',
                        checkout_total: newCheckoutTotal
                    };
                });
                console.log('Size 2 : ' + this.state.checkout_projects.length)
                return;
            }
            doc.src = uncheck;
            console.log('Size : ' + this.state.checkout_projects.length)
            this.setState(prevState => {
                let newProjects = prevState.checkout_projects.filter((item) => item !== project);
                let newCheckoutTotal = prevState.checkout_total === 0 ? 0 : prevState.checkout_total - 10000;
                //newProjects.push(userId);
                if (newProjects.length === 0){
                    return {
                        checkout_projects: newProjects, checkout_disabled_btn: 'table-row',
                        checkout_enabled_btn: 'none',
                        checkout_total: newCheckoutTotal
                    };
                } else {
                    return {
                        checkout_projects: newProjects, checkout_disabled_btn: 'none',
                        checkout_enabled_btn: 'table-row',
                        checkout_total: newCheckoutTotal
                    };
                }
            });
        } catch (e) {
            console.log(e)
        }
    }

    render() {

        return (<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding: 0, height: '70vh', overflow: "auto"}}>

                <div className={"row"} style={{width: '94%', margin: '2%'}}>
                    <table>
                        <tbody>
                        <tr>
                            <td className={'label'} style={{width: '100%'}}>Land Use Type</td>
                        </tr>
                        <tr>
                            <td>
                                <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_type')}
                                               parameters={this.state.projectOptions}/>
                            </td>
                        </tr>

                        <tr>
                            <td style={{width: '100%'}}>
                                <table style={{width: '100%'}}>
                                    <tbody>

                                    <tr style={{display: this.state.is_zonal}}>
                                        <td colSpan={2} className={'label'}>Zone</td>
                                    </tr>
                                    <tr style={{display: this.state.is_zonal}}>
                                        <td colSpan={2}>
                                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'zone')}
                                                           parameters={this.state.zoneOptions}
                                                           isMulti={this.state.is_zonal_multi}/>
                                        </td>
                                    </tr>
                                    <tr style={{display: this.state.is_regional}}>
                                        <td colSpan={2} className={'label'}>Regions</td>
                                    </tr>
                                    <tr style={{display: this.state.is_regional}}>
                                        <td colSpan={2}>
                                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'region')}
                                                           parameters={this.state.regionOptions}
                                                           isMulti={this.state.is_regional_multi}
                                                           isDisable={this.state.is_regional_disabled}/>
                                        </td>
                                    </tr>
                                    <tr style={{display: this.state.is_district}}>
                                        <td colSpan={2} className={'label'}>District/Council</td>
                                    </tr>
                                    <tr style={{display: this.state.is_district}}>
                                        <td colSpan={2}>
                                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'district')}
                                                           parameters={this.state.districtOptions}
                                                           isMulti={this.state.is_district_multi}
                                                           isDisable={this.state.is_district_disabled}/>
                                        </td>
                                    </tr>

                                    <tr style={{display: this.state.is_ward}}>
                                        <td colSpan={2} className={'label'}>Ward</td>
                                    </tr>
                                    <tr style={{display: this.state.is_ward}}>
                                        <td colSpan={2}>
                                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'ward')}
                                                           parameters={this.state.wardOptions}
                                                           isMulti={this.state.is_ward_multi}
                                                           isDisable={this.state.is_ward_disabled}/>
                                        </td>
                                    </tr>

                                    <tr style={{display: this.state.is_village}}>
                                        <td colSpan={2} className={'label'}>Villages</td>
                                    </tr>
                                    <tr style={{display: this.state.is_village}}>
                                        <td colSpan={2}>
                                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'village')}
                                                           parameters={this.state.villageOptions}
                                                           isMulti={this.state.is_village_multi}
                                                           isDisable={this.state.is_village_disabled}/>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>

                            </td>

                        </tr>

                        </tbody>
                    </table>

                    <div style={{display: this.state.search_button, textAlign: 'center', width: '98%', float: 'left'}}>
                        <button className={'btn submit'} onClick={this.search}>
                            <span className={'fa fa-search'}/>Search Land Use
                        </button>
                    </div>

                </div>

                <div className={"row"} style={{width: '94%', margin: '2%'}}>
                    <div style={{
                        display: this.state.search_success,
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        width: '100%'
                    }} className={'col col-sm-12'}>
                        <table className={'tb'} style={{margin: '1%', width: '100%'}}>
                            <thead>
                            <tr>
                                <th>No.</th>
                                <th style={{position: 'sticky', left: 0, zIndex: 2}}>Land Use Name</th>
                                <th>Expiry Date</th>
                                <th>Price</th>
                                <th>Selected</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.projects.map((d, i) => {
                                    return (<tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>
                                            <span style={{color: 'darkcyan'}}>{d.name}</span>
                                        </td>
                                        <td>{d.datetime}</td>
                                        <td>10,000</td>
                                        <td style={{textAlign: 'center', backgroundColor: 'white', width: '5%'}}>
                                            <img id={'chk_' + (i + 1)} alt={'chk_' + (i + 1)} src={uncheck}
                                                 onClick={() => this.toggleCheck(i + 1, d)}/>
                                        </td>
                                    </tr>)
                                })
                            }
                            </tbody>
                        </table>


                        <div className={"row"}>
                            <div style={{
                                display: this.state.checkout_enabled_btn,
                                overflowX: 'hidden',
                                overflowY: 'auto',
                                border: 'lightgray',
                                backgroundColor:'whitesmoke',
                                borderStyle: 'dashed',
                                marginLeft: '2%',
                            }} className={'col col-sm-6'}>
                                <center className={"row"} style={{fontSize: '17px', padding: '10px', paddingTop: '15px'}}>
                                    <b>Purchase List</b></center>
                                {
                                    this.state.checkout_projects.map((d, i) => {
                                        return (<div><div style={{padding: '5px', fontSize: '16px'}} className={"row"} key={i}>
                                            <div className={'col col-sm-2'}></div>
                                            <div className={'col col-sm-1'}>
                                                <span>{i + 1 +'.'}</span>
                                            </div>
                                            <div className={'col col-sm-5'}>
                                                <span>{d.name}</span>
                                            </div>
                                            <div className={'col col-sm-2'}>
                                                <span>10,000</span>
                                            </div>
                                        </div>
                                        </div>)
                                    })
                                }

                                <center  style={{
                                    borderTop: 'lightgray',
                                    borderBottom : 'whitesmoke',
                                    borderLeft : 'whitesmoke',
                                    borderRight : 'whitesmoke',
                                    borderStyle: 'dashed',
                                    marginLeft : '18%',
                                    marginRight: '18%'
                                }} className={"row"}></center>

                                <div  style={{padding: '5px', fontSize: '16px'}} className={"row"}>
                                    <div className={'col col-sm-3'}></div>
                                    <div className={'col col-sm-5'} style={{textAlign: 'center'}}>
                                        <span><b>Total</b></span>
                                    </div>
                                    <div className={'col col-sm-2'}>
                                        <span><b>{this.state.checkout_total.toLocaleString()}</b></span>
                                    </div>
                                </div>
                            </div>
                            <div style={{
                                display: this.state.search_success,
                                overflowX: 'hidden',
                                overflowY: 'auto',
                            }} className={'col col-sm-5'}>
                                <center style={{textAlign: 'center', width: '100%', float: 'right', marginBottom: '1%', paddingTop: '15%'}}>
                                   {/* <button className={'btn'} onClick={this.search} disabled={true}
                                            style={{display: this.state.checkout_disabled_btn, backgroundColor: '#cccccc'}}>
                                        <span className={'fa fa-shopping-cart'}/>Generate Bill
                                    </button>*/}
                                    <button className={'btn'} onClick={this.checkout} disabled={false}
                                            style={{display: this.state.checkout_enabled_btn, backgroundColor: '#0099cc'}}>
                                        <span className={'fa fa-shopping-cart'}/>Generate Bill
                                    </button>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>)
    }

    search() {
        try {
            let locality

            switch (this.state.locality) {
                case 'Village':
                    locality = this.state.village
                    break
                case 'Ward':
                    locality = this.state.ward
                    break
                case 'District':
                    locality = this.state.district
                    break
                case 'Regional':
                    locality = this.state.region
                    break
                case 'Zonal':
                    locality = this.state.zone
                    break
                case 'National':
                    locality.push(sessionStorage.getItem('national_level_id'))
                    break
            }
            console.log(locality.value)

            Wait.show('Searching Land Uses...')
            ProjectsService.fetchPublishedProjects(locality.value).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        projects: r.data.results,
                        totalPages: r.data.count,
                        next: r.data.next,
                        previous: r.data.previous,
                        search_success: 'table-row'
                    })
                    this.resetChecked()
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            alert(e)
        }
    }

    submit() {
        try {
            let name = this.state.name
            let desc = this.state.description
            let project_type = this.state.project_type.value
            let project = this.state.project_existence.value
            let budget = this.state.budget

            let project_funder = []
            let locality = []

            switch (this.state.locality) {
                case 'Village':
                    this.state.village.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'District':
                    this.state.district.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'Regional':
                    this.state.region.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'Zonal':
                    this.state.zone.forEach(it => {
                        locality.push(it.value)
                    })
                    break
                case 'National':
                    locality.push(sessionStorage.getItem('national_level_id'))
                    break
                default:
                    this.state.zone.forEach(it => {
                        locality.push(it.value)
                    })
            }

            ProjectsService.createProject({
                name: name,
                description: desc,
                locality_ids: locality,
                project_type: project_type,
                project: project,
                funder_ids: project_funder,
                budget: budget,
                reg_date: '',
            }).then(r => {
                this.props.loadProjects()
                PopDetail.dismiss()
            })

        } catch (e) {
            alert(e)
        }
    }

    checkout() {
        try {
            let checkout_projects = []
            this.state.checkout_projects.forEach(it => {
                console.log("REF : " + it.name)
                checkout_projects.push(it)
            })

            /* ProjectsService.createProject({
                 name: name,
                 description: desc,
                 locality_ids: locality,
                 project_type: project_type,
                 project: project,
                 funder_ids: project_funder,
                 budget: budget,
                 reg_date: '',
             }).then(r => {
                 this.props.loadProjects()
                 PopDetail.dismiss()
             })*/

        } catch (e) {
            alert(e)
        }
    }


}